export const createCanvas = function Canvas(w: number, h: number) {
  const canvas = document.createElement('canvas')
  canvas.width = w || 300
  canvas.height = h || 150
  return canvas
}

/**
 * Change the image to blank and white using a simple threshold
 *
 * @param  {object} image The imageData of a Canvas 2d context
 * @param  {number} threshold Threshold value (0-255)
 * @return {ImageData} The resulting imageData
 */
export function canvasThreshold(image: ImageData, threshold: number): ImageData {
  for (let i = 0; i < image.data.length; i += 4) {
    const luminance = image.data[i] * 0.299 + image.data[i + 1] * 0.587 + image.data[i + 2] * 0.114

    const value = luminance < threshold ? 0 : 255
    image.data.fill(value, i, i + 3)
  }

  return image
}

/**
 * Change the image to grayscale
 *
 * @param  {object} image The imageData of a Canvas 2d context
 * @param  {array} background Three values consisting of the r, g, b of the background
 * @return {ImageData} The resulting imageData
 */
export function canvasFlatten(image: ImageData, background: [number, number, number]): ImageData {
  for (let i = 0; i < image.data.length; i += 4) {
    const alpha = image.data[i + 3]
    const invAlpha = 255 - alpha

    image.data[i] = (alpha * image.data[i] + invAlpha * background[0]) / 255
    image.data[i + 1] = (alpha * image.data[i + 1] + invAlpha * background[1]) / 255
    image.data[i + 2] = (alpha * image.data[i + 2] + invAlpha * background[2]) / 255
    image.data[i + 3] = 0xff
  }

  return image
}
